import React, { useRef, useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import getImagePath from "helpers/get-image-path";
import getFilePath from "helpers/get-file-path";
import playVideoButton from "assets/images/play-video-button.png";
import {
  testimonial, testimonialSlider, testimonialCardVideoButton,
  testimonialVideoText, testimonialCardPlay, testimonialCardTitle,
  testimonialCard, testimonialCardVideo, testimonialCardVideoButtonContainer,
  testimonialVideoTextParagraph, testimonialVideoTextIcon, testimonialCardTitleMain
} from "./style.mod.scss";
import locale from "locales";

const VideoTag = (props) => {
  const _vidRef = useRef(null);
  const _sourceRef = useRef(null);
  const [active, setActive] = useState(false);
  const url = props.shopifyURL ? props.shopifyURL : props.src;

  useEffect(() => {
    const video = _vidRef?.current;
    const source = _sourceRef?.current;
    if (!video || !source) return;

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!source.src) {
              source.src = source.dataset.src;
              video.load();
            }
            observerInstance.unobserve(video);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(video);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video = _vidRef?.current;
    if (!video) return;

    if (video.ended) {
      video.pause();
      video.load();
      video.currentTime = 0;
    } else if (active) video.play();
    else video.pause();
  }, [active]);

  const activeClass = active ? testimonialCardPlay : "";

  return (
    <div className={`${testimonialCard} ${activeClass}`}>
      <div onClick={() => setActive(!active)} className={activeClass}>
        <video
          ref={_vidRef}
          className={props.videoClassName}
          poster={props.poster}
          autoPlay={props.autoPlay}
          muted={props.muted}
          playsInline={props.playsInline}
          loop={false}
          preload="none"
          onEnded={() => setActive(false)}
        >
          {locale.dev.videoNoSupport}
          <source ref={_sourceRef} data-src={url} type="video/mp4" />
        </video>
        <button
          className={testimonialCardVideoButtonContainer}
          onClick={(e) => {
            e.stopPropagation();
            setActive(!active);
          }}
        >
          <img
            className={testimonialCardVideoButton}
            src={playVideoButton}
            alt={locale.altText.playVideoIcon} />
        </button>
      </div>
      <div className={testimonialVideoText}>
        <img
          className={testimonialVideoTextIcon}
          srcSet={getImagePath(props.icon, true)}
          alt={props.icon.alt} />
        <h5 className={testimonialVideoTextParagraph}>{props.title}</h5>
      </div>
    </div>
  );
};

const VideoTestimonial = ({ data }) => {
  const { video } = data;
  const mainTitle = data.title;

  var settings = {
    noSwiping: true,
    spaceBetween: 0,
    slidesPerView: 1,
    loop: false,
    modules: [Pagination],
    lazy: true,
    pagination: { clickable: true },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 50,
        dots: true,
        noSwiping: false,
      },
      992: {
        pagination: false,
        slidesPerView: 3,
        spaceBetween: 30,
        noSwipingClass: "swiper-wrapper",
        dots: false
      },
      1200: {
        noSwiping: true,
        noSwipingClass: "swiper-wrapper",
        slidesPerView: 3,
        spaceBetween: 30,
        dots: false
      },
      1399: {
        noSwiping: true,
        noSwipingClass: "swiper-wrapper",
        slidesPerView: 3,
        spaceBetween: 70,
        dots: false
      },
      1920: {
        noSwiping: true,
        noSwipingClass: "swiper-wrapper",
        slidesPerView: 3,
        spaceBetween: 70,
        dots: false
      },
      2560: {
        noSwiping: true,
        noSwipingClass: "swiper-wrapper",
        slidesPerView: 3,
        spaceBetween: 70,
        dots: false
      }
    }
  };

  return (
    <div className={testimonial}
      style={{ backgroundColor: data.jumbotronBgColor && data.jumbotronBgColor.hex }}>
      <Container>
        <h2 className={`${testimonialCardTitle} ${testimonialCardTitleMain}`}>{mainTitle}</h2>
        <Swiper {...settings} className={testimonialSlider} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
          {
            video?.map((singleVideo, index) => {
              const { title, thumbnail, video, icon } = singleVideo;
              return (
                <SwiperSlide key={index}>
                  {
                    (index === 1) &&
                    (
                      <h2 className={testimonialCardTitle}>{mainTitle}</h2>
                    )
                  }
                  <VideoTag
                    videoClassName={testimonialCardVideo}
                    poster={getImagePath(thumbnail)}
                    src={getFilePath(video)}
                    type="video/mp4"
                    shopifyURL={singleVideo.videoURL}
                    autoPlay={false}
                    muted={true}
                    playsInline={true}
                    icon={icon}
                    title={title}
                  />
                </SwiperSlide>
              );
            })
          }
        </Swiper>
      </Container>
    </div>
  );
};

export default VideoTestimonial;
